import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GenericNoContentDueToFilteringError = ({
  headingI18n,
  subtitleI18n,
  resetLink,
  onReset
}) => /*#__PURE__*/_jsx(ErrorMessage, {
  "data-test-id": "no-content-error",
  illustration: "empty-state-charts",
  title: /*#__PURE__*/_jsx(H4, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyErrors.filters.${headingI18n}`
    })
  }),
  children: /*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyErrors.filters.common.${subtitleI18n}`
    }), /*#__PURE__*/_jsx("br", {}), resetLink && /*#__PURE__*/_jsx(RouterLink, {
      "data-test-id": "clear-all-filters",
      onClick: onReset,
      to: resetLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyErrors.filters.common.clearFilters"
      })
    })]
  })
});
export default GenericNoContentDueToFilteringError;